import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Divider from './Divider';
import RmaLogic from '../Logic/Logic.ts'
import { Email, Item, Span, Image, A, renderEmail } from 'react-html-email';
import ErrorBoundary from './ErrorBoundary'
import {
  parseStoredJson,
  normalizeBuildReturnResult,
  buildInstructionsUrl,
  buildStatusPageUrl,
  buildEmailShipInstructionsPayload,
  getPrepaidStepImageBase,
  normalizeEmail,
  isValidEmail,
  GENERIC_ERROR_MESSAGE,
  GENERIC_EMAIL_ERROR_MESSAGE,
} from '../Logic/ReturnEmailData.ts'

class Results extends Component {
  constructor(props) {
    super()

    const isLocalhost = Boolean(
      window.location.hostname === 'localhost' ||
      window.location.hostname === '[::1]' ||
      window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
      )
    );

    this.state = {
      email: '',
      emailError: '',
      confirmEmail: '',
      instructionsUrl: '',
      logic: new RmaLogic(),
      emailBody: { __html: '' },
      orderInfo: {},
      emailSentToCustomerService: false,
      isLocalhost: isLocalhost,
      saleUrl: '',
      isSendingEmail: false,
      emailSendMessage: '',
    }
  }

  componentDidMount = async () => {
    try {
      const orderInfo = parseStoredJson('orderInfo', {})
      const results = normalizeBuildReturnResult(parseStoredJson('buildReturnResult', {}), orderInfo)
      const instructionsUrl = buildInstructionsUrl(results.shippingInstructionsFileName)

      this.setState({
        orderInfo,
        results,
        saleUrl: results.returnOrderId
          ? `https://braceability.fulfil.io/client/#/model/sale.sale/${results.returnOrderId}`
          : '',
        instructionsUrl,
        isReship: results.isReship,
      })

      if (orderInfo.mailToCustomer && !orderInfo.emailSentToCustomerService) {
        const notifyEmail = this.state.isLocalhost ? 'developer@braceability.com' : 'support@braceability.com'
        const sent = await this.emailShipInstructions(notifyEmail, true)
        if (sent) {
          orderInfo.emailSentToCustomerService = true
          localStorage.setItem('orderInfo', JSON.stringify(orderInfo))
        }
      }
    } catch (error) {
      console.log('Results page load failed', error)
    }
  }

  printNowButton = () => {
    if (!this.state.instructionsUrl) {
      this.setState({ emailError: GENERIC_ERROR_MESSAGE })
      return
    }
    window.open(this.state.instructionsUrl)
  }

  sendEmailClick = async () => {
    await this.validateEmailAddresses()
  }

  closeClick = () => {
    localStorage.setItem('orderInfo', '')
    this.props.history.replace('/pages/returns')
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
      emailError: '',
      emailSendMessage: '',
    })
  }

  validateEmailAddresses = async () => {
    const email = normalizeEmail(this.state.email)
    const confirmEmail = normalizeEmail(this.state.confirmEmail)

    if (email !== confirmEmail) {
      this.setState({ emailError: 'The two email addresses entered do not match.' })
      return
    }

    if (!isValidEmail(email)) {
      this.setState({ emailError: 'Please enter a valid email address.' })
      return
    }

    const sent = await this.emailShipInstructions(email)
    if (sent) {
      this.setState({ emailError: '', emailSendMessage: 'Shipping instructions have been emailed to you.' })
    }
  }

  render() {
    return (
      <ErrorBoundary>
        <Grid container direction="column" justify="center" alignItems="center" spacing={0}>
          <Grid item>
            {this.state?.orderInfo?.forCustomerService && this.state?.results?.errors?.length > 0 && (
              <Typography variant='subtitle2' display='block' component="div" color='error'>
                {GENERIC_ERROR_MESSAGE}
              </Typography>
            )}
            {this.state.isReship ?
              <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={0}>
                <Typography variant="h6" display="block" component="div">Your duplicate order has been created.</Typography>
                <Link style={{ marginTop: '1px', marginLeft: '5px', fontSize: '2rem' }} target="_blank" rel="noopener noreferrer" href={this.state.saleUrl}>
                  {this.state.results.returnOrderNumber} ({this.state.orderInfo.reference}-RESHIP)
                </Link>
              </Grid>
              : <></>}
            <Typography variant="h6" display="block" component="div">Shipping Instructions</Typography>
            {this.state.orderInfo.mailToCustomer ?
              <Typography variant="subtitle1" display="block" component="div">
                We will mail you a copy of your shipping instructions and return shipping label. You may enter your email below if you would like to receive a digital copy for your records.
              </Typography>
              :
              <>
                <Typography variant="subtitle1" display="block" component="div">
                  Print now, or enter your email address to receive a copy of the label and return instructions. You must include the return paperwork in your return package or processing will be delayed.
                </Typography>
                <Button variant="outlined" color="primary" onClick={this.printNowButton}>Print Now</Button>
              </>
            }
            <Divider />
            <TextField
              error={Boolean(this.state.emailError)}
              id="email"
              label="Email"
              type="email"
              value={this.state.email}
              margin="dense"
              onChange={this.handleChange('email')}
              helperText={this.state.emailError || this.state.emailSendMessage}
              variant="outlined"
              style={{ width: '95%' }}
              disabled={this.state.isSendingEmail}
            />
            <TextField
              error={Boolean(this.state.emailError)}
              id="confirmEmail"
              label="Confirm Email"
              type="email"
              value={this.state.confirmEmail}
              margin="dense"
              onChange={this.handleChange('confirmEmail')}
              helperText={this.state.emailError || 'You must enter an email to receive status updates on your return/exchange.'}
              variant="outlined"
              style={{ width: '95%' }}
              disabled={this.state.isSendingEmail}
            />
            <Divider />
            <Button variant="outlined" color="primary" onClick={this.sendEmailClick} disabled={this.state.isSendingEmail}>
              {this.state.isSendingEmail ? 'Sending...' : 'Send'}
            </Button>
            <Divider />
            <Typography variant="subtitle1" display="block" component="div">
              Your return/exchange will be processed within 1-3 business days of receiving it at our warehouse. You can check the status any time by looking up your order at BraceAbility.com/returns.
            </Typography>
            <div className="Polaris-Label_HelpText">Need help? Contact us at <Link target="_blank" rel="noopener noreferrer" href="mailto:support@braceability.com">Support@BraceAbility.com</Link> or <Link target="_blank" rel="noopener noreferrer" href="tel:866-712-7808">866-712-7808</Link></div>
            <Divider />
            <Button variant="contained" color="primary" onClick={this.closeClick}>Close</Button>
          </Grid>
          <Grid item dangerouslySetInnerHTML={this.state.emailBody} />
          <div style={{ marginTop: 20 }} />
        </Grid>
      </ErrorBoundary>
    )
  }

  emailShipInstructions = async (emailAddress, silentFailure) => {
    const orderInfo = parseStoredJson('orderInfo', this.state.orderInfo || {})
    const results = normalizeBuildReturnResult(parseStoredJson('buildReturnResult', {}), orderInfo)
    const instructionsUrl = buildInstructionsUrl(results.shippingInstructionsFileName)
    const statusLinkRef = buildStatusPageUrl(orderInfo.reference || results.returnOrderNumber, results.zip || orderInfo.zip)
    const orderTitle = results.returnOrderNumber || orderInfo.reference || 'your order'
    const imgSize = 200
    const baseStepUrl = getPrepaidStepImageBase(orderInfo)

    this.setState({ isSendingEmail: true, emailError: '', emailSendMessage: '' })

    try {
      const emailBody = renderEmail(
        <Email align="left" title={`Shipping Instructions for ${orderTitle}`}>
          <Item align="left">
            <Image align="left" alt="www.braceability.com" lineHeight={40} src="https://cdn.shopify.com/s/files/1/0011/7958/2517/files/logo_410x.png?v=1522074313" width={180} height={25.5} />
          </Item>
          <Item align="left">
            <Span align="left" lineHeight={8} fontSize={12}>Reference Number: {orderInfo.reference || results.returnOrderNumber}</Span>
          </Item>
          <Item align="left">
            <h2 style={{ margin: 0, marginTop: 15, padding: 0 }}>We&apos;re so sorry that our braces didn&apos;t work for you!</h2>
            <h4 style={{ margin: 0, marginTop: 15, padding: 0 }}>But don&apos;t worry, the rest of this process is very easy.</h4>
          </Item>
          <Item align="left">
            <p>
              <A href="https://www.braceability.com/returns#eligible">
                <h4 style={{ margin: 0, marginTop: 15, padding: 0 }}>Did you already check to make sure your brace is eligible for return?</h4>
              </A>
              <ul style={{ margin: 0, marginLeft: 15, padding: 0, lineHeight: '15px' }}>
                <li style={{ margin: 0, marginLeft: 15, padding: 0 }}><p>Product must be unused</p></li>
                <li style={{ margin: 0, marginLeft: 15, padding: 0 }}><p>Exchanges must be received within 30 days of your original order date.</p></li>
                <li style={{ margin: 0, marginLeft: 15, padding: 0 }}><p>If we receive an item which is ineligible for a refund per our policies we will not be able to send the item back to you.</p></li>
              </ul>
            </p>
          </Item>
          <Item align="left">
            <Span align="left" lineHeight={40} style={{ fontWeight: 'normal', fontSize: '24px' }} fontSize={10}>How to send your brace back:</Span>
          </Item>
          <Item>
            <table cellPadding="0" cellSpacing="8" style={{ borderCollapse: 'collapse' }}>
              <tbody>
                <tr>
                  <td><Image alt="step one" height={imgSize} width={imgSize} src={baseStepUrl + 'step-1.png'} /></td>
                  <td><Image alt="step two" height={imgSize} width={imgSize} src={baseStepUrl + 'step-2.png'} /></td>
                  <td><Image alt="step three" height={imgSize} width={imgSize} src={baseStepUrl + 'step-3.png'} /></td>
                </tr>
              </tbody>
            </table>
          </Item>
          {instructionsUrl ? (
            <Item align="center">
              <div style={{ maxWidth: 280, borderRadius: 10, backgroundColor: '#1177e9', marginTop: 15, padding: '10px 20px' }}>
                <A href={instructionsUrl} style={{ textDecoration: 'none', color: '#FFFFFF' }}>
                  <strong>Download your shipping label and return instructions</strong>
                </A>
              </div>
            </Item>
          ) : null}
          <Item>
            <p>We do our best to process each return the same day it&apos;s received at our warehouse, but occasionally it can take up to three business days. Don&apos;t forget, we will refund the full product cost, but unfortunately all <A href="https://www.braceability.com/returns#refund-amount"><strong>original shipping charges are nonrefundable</strong></A>.</p>
          </Item>
          <Item align="center">
            <div style={{ maxWidth: 220, borderRadius: 10, backgroundColor: '#1177e9', marginTop: 15, padding: '10px 20px' }}>
              <A href={statusLinkRef} style={{ textDecoration: 'none', color: '#FFFFFF' }}>
                I want to<strong> check the status of my return, exchange or refund.</strong>
              </A>
            </div>
          </Item>
        </Email>
      )

      const requestPayload = buildEmailShipInstructionsPayload(
        emailAddress,
        emailBody,
        results,
        orderInfo
      )

      if (!requestPayload) {
        this.setState({ isSendingEmail: false })
        if (!silentFailure) {
          this.setState({ emailError: GENERIC_EMAIL_ERROR_MESSAGE })
        }
        return false
      }

      const response = await this.state.logic.postEmailShipInstructions(requestPayload)

      this.setState({ isSendingEmail: false })
      if (!response.success) {
        if (!silentFailure) {
          this.setState({ emailError: GENERIC_EMAIL_ERROR_MESSAGE })
        }
        return false
      }
      return true
    } catch (error) {
      console.log('emailShipInstructions failed', error)
      this.setState({ isSendingEmail: false })
      if (!silentFailure) {
        this.setState({ emailError: GENERIC_EMAIL_ERROR_MESSAGE })
      }
      return false
    }
  }
}

const ResultsWithRouter = withRouter(Results)
export default ResultsWithRouter
